import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M39.75 11.387h-9.268C30.226 8.031 27.42 5.378 24 5.378s-6.226 2.653-6.482 6.009H8.25v3h3.591v27.989h24.318V14.387h3.591zM24 8.378c1.763 0 3.212 1.312 3.457 3.009h-6.914C20.788 9.69 22.237 8.378 24 8.378m9.159 30.998H14.841V14.387h18.318z" }) }) })
});
export default SvgDelete;
